<div [hash]="id"
    *ngIf="!item.agent ||  ((item.agent?.mobile == 'true' && agent.mobile) || (item.agent?.desktop == 'true' && agent.desktop))">
    <div [class]="item.grid+' '+item.gridClass+' '+item.gap+' '+_customGrid">
        <ng-container  *ngFor="let subItem of item.children" >
        <div *ngIf="!subItem.agent ||  ((subItem.agent?.mobile == 'true' && agent.mobile) || (subItem.agent?.desktop == 'true' && agent.desktop))"
            class="{{subItem.class}} {{(subItem.span)?subItem.span:'col-span-1'}}">
            <div class="{{isMainLayout?'container':''}}">
                <app-block-grid [agent]="agent" [parentItem]="item" [item]="subItem" [blocksRef]="blocksRef"
                [id]="subItem._id" [customGrid]="subItem.customGrid"  [grid]="subItem.grid" [span]="subItem.span"
                [gridClass]="subItem.class"></app-block-grid>
            </div>
           
        </div>
    </ng-container>
    </div>
</div>